// frontend/src/marketing/docsContent.js
//
// Registry of public documentation pages. The markdown is imported raw (Vite's
// ?raw) from src/content/docs/ — mirrored from docs/knowledge/ by
// scripts/sync-docs.sh so the public docs match the AI knowledge base.
import gettingStarted from "../content/docs/qrflow-getting-started.md?raw";
import apiReference from "../content/docs/qrflow-api-reference.md?raw";
import faq from "../content/docs/qrflow-faq.md?raw";
import troubleshooting from "../content/docs/qrflow-troubleshooting.md?raw";
import { slugify } from "./Markdown";

export const DOCS = [
  {
    slug: "getting-started",
    title: "Getting started",
    description: "From sign-up to tracking your first scans in about five minutes.",
    body: gettingStarted,
  },
  {
    slug: "api",
    title: "API reference",
    description: "Authenticate with scoped keys and manage codes and analytics over REST.",
    body: apiReference,
  },
  {
    slug: "faq",
    title: "FAQ",
    description: "Answers to the questions we hear most often.",
    body: faq,
  },
  {
    slug: "troubleshooting",
    title: "Troubleshooting",
    description: "Fix scanning issues, redirects, and common setup problems.",
    body: troubleshooting,
  },
];

export function getDoc(slug) {
  return DOCS.find((d) => d.slug === slug) || null;
}

/**
 * Build an in-page table of contents from a markdown string by scanning ## and
 * ### headings. Slugs match the ids the Markdown renderer assigns to headings.
 */
export function buildToc(markdown) {
  const lines = markdown.split("\n");
  const toc = [];
  let inFence = false;
  for (const line of lines) {
    if (line.trim().startsWith("```")) {
      inFence = !inFence;
      continue;
    }
    if (inFence) continue;
    const m = /^(#{2,3})\s+(.*)$/.exec(line);
    if (m) {
      const text = m[2].replace(/[#*`]/g, "").trim();
      toc.push({ depth: m[1].length, text, id: slugify(text) });
    }
  }
  return toc;
}
